// Extract context and hook from Provider to fix Lint warning about fast refresh
import { createContext, useContext } from 'react';
import { Event } from '@type/db-types';

export interface ModalContextValues {
    showEventModal: string | Event | boolean;
    setShowEventModal: (open: boolean) => void;
    setShowTeamModal: (createOrViewId: boolean | string) => void;
    setShowAddTeamMember: (createOrViewId: boolean | string) => void;
    setShowAddChildModal: (createOrViewId: boolean | string) => void;
    setShowImportModal: (open: boolean) => void;
    setShowTeamImportModal: (open: boolean) => void;
    // showWrestlerModal: boolean;
}

export const ModalContext = createContext<ModalContextValues>({
    showEventModal: false,
    setShowEventModal: () => {},
    setShowTeamModal: () => {},
    setShowAddTeamMember: () => {},
    setShowAddChildModal: () => {},
    setShowImportModal: () => {},
    setShowTeamImportModal: () => {},
});

// Access auth context values and functions
const useModalControl = () => {
    const ctx = useContext(ModalContext);

    if (!ctx) console.error('useModalControl called outside of ModalProvider Context');

    return ctx;
};

export default useModalControl;
